import "./App.css";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { NetworkCalls } from "./NetworkCalls";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export default function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
  axios.defaults.withCredentials = true;

  let navigate = useNavigate();

  useEffect(() => {
      const interceptorId = axios.interceptors.response.use(
          (response) => {
              if (response?.data) {
                  response.data = NetworkCalls.handleDates(response.data);
              }
              return response;
          },
          (error) => {
              const status = error?.response?.status;

              // Mark error for error boundaries to handle navigation
              // This allows error boundaries to decide whether to navigate
              error.navigationRequired = status === 401 || status === 500;
              error.navigationPath = status === 401 ? '/login' : '/ups';

              // For backward compatibility, still navigate here for now
              // Error boundaries will override this behavior when they're in place
              switch (status) {
                  case 401:
                      navigate("/login");
                      break;
                  case 500:
                      navigate("/ups");
                      break;
                  default:
                      break;
              }
              return Promise.reject(error);
          }
      );

      return () => axios.interceptors.response.eject(interceptorId);
  }, [navigate]);

  const [queryClient] = useState(() =>
    new QueryClient({
      defaultOptions: {
        queries: {
          // Stale time to reduce unnecessary refetches (5 minutes)
          staleTime: 5 * 60 * 1000,

          // Let error boundaries handle errors
          throwOnError: false,

          // Retry configuration
          retry: (failureCount, error: any) => {
            // Don't retry on 401 (unauthorized) or 404 (not found)
            if (error?.response?.status === 401 || error?.response?.status === 404) {
              return false;
            }
            // Retry up to 2 times for other errors
            return failureCount < 2;
          },
        },
        mutations: {
          // Let error boundaries handle mutation errors
          throwOnError: false,
        },
      },
    })
  );

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <div id="details">
          <Outlet />
        </div>
      </QueryClientProvider>
    </>
  );
}
